import { type FC, useContext, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useCheckVIPstatus } from '@/common/hooks/checkVIPstatus';
import { H2, H3, TextSmall } from '@/components/Typography/Typography';
import { Close } from '@/components/ui/Close/Close';
import { Picture } from '@/components/ui/Picture/Picture';
import VipPlateIcon from '@/components/ui/VipPlateIcon/VipPlateIcon';
import { useAppSelector } from '@/redux/store';

import { WavesBackground } from '../Backgrounds/WavesBackground/WavesBackground';
import { ModalContext } from '../Modal/config';

import { EarnRevenueList } from './EarnRevenueList/EarnRevenueList';

import css from './styles.module.scss';

import usdStarPng from '/img/usd-star-huge.png';
import usdStarWebp from '/img/usd-star-huge.webp';

const EarnTonFromPartners: FC = () => {
  const statusVIP = useCheckVIPstatus();
  const { closeModal } = useContext(ModalContext);
  const referralCryptoRewards = useAppSelector(
    (state) => state.user.extendedInfo?.referralCryptoRewards,
  );
  const transformedData = useMemo(
    () =>
      referralCryptoRewards &&
      Object.entries(referralCryptoRewards).map(([volume, percentage]) => ({
        percentage,
        volume: Number(volume),
      })),
    [referralCryptoRewards],
  );
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col relative pb-14">
      {statusVIP && (
        <VipPlateIcon classNames="relative z-[5] rounded-tl-[16px] rounded-tr-[0px] rounded-br-[16px] rounded-bl-[0px] max-w-[135px] justify-center py-[8px] gap-[4px]">
          <span>{t('+5% With')}</span>
        </VipPlateIcon>
      )}
      <WavesBackground />
      <Close
        onClick={closeModal}
        className="absolute top-4 right-4"
        variant="modal"
        imageVariant="modal"
      />
      <div className="relative z-[2] w-full flex flex-col items-center pt-4 px-10">
        <Picture
          className="aspect-square shrink-0 w-[8rem] mb-4"
          img={usdStarPng}
          webp={usdStarWebp}
          alt="ton star"
        />
        <H2 weight="bold" className="mb-2">
          {t('Earn real money')}
        </H2>
        <TextSmall className={cn(css.subTitle)}>
          <Trans
            i18nKey={
              'Earn <1>up to 11%</1> from your partners purchases! It works for all purchases made with TON and Stars. The more your partners spend, the bigger your share'
            }
            components={{
              1: <span />,
            }}
          />
        </TextSmall>
        <H3 weight="bold" className="mb-[1.125rem]">
          {t('Take a larger piece of the pie')}
        </H3>
        {transformedData && (
          <EarnRevenueList statusVIP={statusVIP} data={transformedData} />
        )}
      </div>
    </div>
  );
};

export { EarnTonFromPartners };
